import * as React from 'react';

import { newPopup as Popup } from '@sunbit-dev/web-ui-lib';
import { PrivacyAllowanceLayer } from '@sunbit-dev/purchase-common/src/components/privacyAllowanceLayer/PrivacyAllowanceLayer';

// ############################ Imported from Old UI ###########################

export interface IErrorModalProps {
  title: string;
  // tslint:disable-next-line: ban-types
  description: string | Function;
  button: string;
  isOpen: boolean;
  errorCode?: string;
  payload?: any;
  submit: () => void;
}

// tslint:disable-next-line:variable-name
const ErrorModal: React.FC<IErrorModalProps> = ({ submit, title, description, payload, button, ...props }) => {
  if (!props.isOpen) return null;

  const content = typeof description === 'function' ? description(payload) : description;

  return (
    <Popup
      {...{
        blueButtonAction: submit,
        blueButtonText: button || 'Exit',
        boldText: title,
        dataAt: 'errorModal',
      }}>
      <PrivacyAllowanceLayer>
        <div dangerouslySetInnerHTML={{ __html: content }} />
      </PrivacyAllowanceLayer>
    </Popup>
  );
};

export default ErrorModal;
